/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
//import Moment from 'react-moment';
import { useRecoilValue } from 'recoil';
import ComplexityStack from '../Shared/ComplexityStack';
import { projectsDataAtom, pgTypesAtom, mobileAtom } from '../Atoms';
import LocalizedDate from './LocalizedDate';

const useStyles = makeStyles({
  info: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '4px',
    paddingLeft: '4px',
  },
});

const PjInfo = function PjInfo({ projectName }) {
  const classes = useStyles();
  const intl = useIntl();
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const pgTypes = useRecoilValue(pgTypesAtom);
  const mobile = useRecoilValue(mobileAtom);

  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === projectName && x.isCurrent === 1));
  }, [projectsData]);
  return (
    <Container disableGutters={!mobile} className={classes.info} sx={{ ml: 0 }}>
      <Container disableGutters className={classes.col}>
        <Typography variant="body2">{intl.messages.KICKOFF}</Typography>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          <b>
            <LocalizedDate value={new Date(currentProjectData?.KickOff)} readOnly variant="standard" />
          </b>
        </Typography>
        <Typography variant="body2">{intl.messages.TYPE}</Typography>
        <Typography variant="subtitle2">
          <b>
            {pgTypes?.find((x) => x.idTipo === currentProjectData?.ProjectType)?.descTipo ||
              currentProjectData?.ProjectType}
          </b>
        </Typography>
      </Container>
      <Container disableGutters className={classes.col}>
        <Typography variant="body2" sx={{ textAlign: 'end' }}>
          {intl.messages.EXPECTEDSOP}
        </Typography>
        <Typography variant="subtitle2" sx={{ mb: 1, textAlign: 'end' }}>
          <b>
            <LocalizedDate value={new Date(currentProjectData?.SopPredicted)} readOnly variant="standard" />
          </b>
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'end' }}>
          {intl.messages.COMPLEXITY}
        </Typography>
        <ComplexityStack />
      </Container>
    </Container>
  );
};

export default PjInfo;
